<template>
  <transition leave-active-class="animated zoomOut">
    <li class="template">
      <div class="template-cover-wrapper">
        <div class="template-overlay">
          <span class="button is-primary is small" @click="$router.push('/a/template/' + template.id)">{{ $t('templates.edit') }}</span>
          <div class="template-hover-bottom">
            <span title="Make a Copy"><i class="icon icon-doc-copy" @click="duplicate()"></i></span>
            <span title="Delete Template"><i class="icon icon-trash" @click="archive()"></i></span>
          </div>
        </div>

        <div class="template-cover" :style="{ 'color': template.cover.color, 'background-color': template.cover.backgroundColor, 'font-family': template.options.documentFont }" :class="classes">
          <div class="company-logo">
            <img :src="template.cover.logo" v-show="template.cover.logo">
          </div>

          <div class="title-client-block">
            <div class="document-title-input" :style="{ 'color': template.cover.color }">{{ template.cover.title }}</div>
            <div class="client-input" :style="{ 'color': template.cover.color }">{{ template.cover.client }}</div>
          </div>

          <div class="created-wrapper">
            <span class="created-by">
              <strong :style="{ 'color': template.cover.color }">{{ $t('templates.created_by') }}</strong>
              <span class="created-by-input" :style="{ 'color': template.cover.color }">{{ template.cover.createdBy }}</span>
            </span>
            <span class="created-for">
              <strong :style="{ 'color': template.cover.color }">{{ $t('templates.created_for') }}</strong>
              <span class="created-for-input" :style="{ 'color': template.cover.color }">{{ template.cover.createdFor ? template.cover.createdFor : $t('templates.n-a') }}</span>
            </span>
          </div>
          <span class="has-bg-img" :style="{ 'background-image': 'url(' + template.cover.backgroundImage + ')' }" v-if="template.cover.backgroundImage"></span>
        </div>
      </div>
      <h3>{{ template.title }}</h3>
    </li>
  </transition>
</template>

<script>
  export default {
    props: ['template'],
    computed: {
      classes() {
        return {
          'layout-1': this.template.cover.layout === 1,
          'layout-2': this.template.cover.layout === 2,
          'layout-3': this.template.cover.layout === 3,
          'layout-4': this.template.cover.layout === 4,
          'alignment-left': this.template.cover.alignment === 'left',
          'alignment-center': !this.template.cover.alignment || this.template.cover.alignment === 'center',
        };
      }
    },
    methods: {
      duplicate() {
        let clone = _.clone(this.template);
        clone.title += ' (Copy)';
        clone.cover.title += ' (Copy)';

        axios.post('/api/template', clone)
          .then(response => {
            this.$router.push('/a/template/' + response.data.id);
          });
      },
      archive() {
        let vm = this;
        Events.$emit('alertModal', {
          title: '',
          body: vm.$t('templates.confirm_archive', { template_title: vm.template.title }),
          actions: ['Yes', 'No'],
          done: function(action) {
            if (action === 'Yes') {
              axios.delete('/api/template/' + vm.template.id)
                .then(function(result) {
                  (new Notyf()).confirm(vm.$t('templates.template_archived'));
                  vm.$emit('delete', vm.template);
                }, function() {
                  (new Notyf()).alert(vm.$t('templates.template_archived_error'));
                });
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  li.template {
    width: 214px;
    position: relative;
    text-align: center;
    margin: 0 20px 25px 0;
    padding: 0;

    h3 {
      margin-top: 15px;
    }

    .template-cover-wrapper {
      position: relative;
      box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.50);

      .template-overlay {
        display: none;
        -webkit-transition: all 0.2s;
        -moz-transition: all 0.2s;
        transition: all 0.2s;
      }

      .template-cover {
        width: 214px;
        height: 275px;

        &.alignment-center {
          .company-logo, .document-title-input, .client-input, .created-wrapper {
            transform: translateX(-50%);
            left: 50%;
          }
          .title-client-block {
            text-align: center;
          }
        }

        .has-bg-img {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background-size: cover;
          z-index: 0;
        }

        .company-logo {
          position: absolute;
          width: 50px;
          left: 15px;
          z-index: 1;
        }

        .title-client-block {
          position: absolute;
          width: 100%;
          padding: 0 15px;
          text-align: left;
        }

        .document-title-input {
          position: relative;
          font-size: 8px;
          z-index: 1;
        }

        .client-input {
          position: relative;
          font-size: 6px;
          z-index: 1;
        }

        .created-wrapper {
          left: 15px;
          text-align: left;
          position: absolute;
          z-index: 1;
          .created-by, .created-for {
            font-size: 6px;
            display: block;
            z-index: 1;
          }
        }

        &.layout-1 {
          .company-logo {
            top: 35px;
          }
          .title-client-block {
            top: 110px;
          }
          .created-wrapper {
            top: 200px;
          }
        }
        &.layout-2 {
          .company-logo {
            top: 65px;
          }
          .title-client-block {
            top: 165px;
          }
          .created-wrapper {
            top: 230px;
          }
        }
        &.layout-3 {
          .company-logo {
            top: 65px;
          }
          .title-client-block {
            top: 165px;
          }
          .created-wrapper {
            top: 230px;
          }
        }
        &.layout-4 {
          .company-logo {
            top: 35px;
          }
          .title-client-block {
            top: 100px;
          }
          .created-wrapper {
            top: 160px;
          }
        }
      }
    }

    &:nth-child(5n+5) {
      margin-right: 0;
    }

    &:hover {
      img {
        border-color: $green;
      }

      .template-cover-wrapper {
        .template-overlay {
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba(255,255,255,0.9);
          border: 1px solid $green;
          padding: 100px 20px 0;
          z-index: 3;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          transition: all 0.2s;
          .button {
            width: 100%;
            margin-bottom: 30px;
          }
          .template-hover-bottom {
            span {
              border: 1px solid $mutedblue;
              border-radius: 100px;
              color: $mutedblue;
              width: 50px;
              height: 50px;
              display: inline-block;
              text-align: center;
              padding-top: 12px;
              margin: 0 5px;
              -webkit-transition: all 0.2s;
              -moz-transition: all 0.2s;
              transition: all 0.2s;
              &:hover {
                cursor: pointer;
                border-color: $green;
                color: $green;
              }
              i {
                margin-left: -3px;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// template-card.vue?54bffa2c